const test_messages = [
  {
    id: 3510563,
    title: "Test Confirmation",
    content:
      '<body><p>DAVID,</p><p>Thank you for choosing STDcheck for your testing needs. \u00a0Your order ID number is: S5qUAMo9Y7.</p><p><strong><u><span style="color: rgb(255, 64, 64); font-size: 18px;">To protect your privacy, we have attached the form you will need to have with you when you visit the lab</span></u><span style="font-size: 18px;"><span style="color: rgb(255, 64, 64);">.\u00a0</span></span></strong><span style="color: rgb(255, 64, 64);"><strong><span style="font-size: 18px;">You can print the attachment, or fax it directly to the lab from the <em>My Orders</em> tab in your online account.</span></strong></span></p><hr><hr><p>Since Clinical Pathology Labs will perform your testing, you may visit any Clinical Pathology Labs facility of your choice. To find a nearby Clinical Pathology Labs location please <a href="http://www.cpllabs.com/locations/patient-service-centers.aspx" rel="noopener noreferrer" target="_blank">click here</a>.\u00a0</p><p> \u00a0</p><p><span style="background-color: initial; font-size: 0.875rem;">You can visit the lab at your earliest convenience within the lab\u2019s business hours. Appointments aren\u2019t required but can be made by visiting the laboratory\'s website. \u00a0</span></p><p><span style="color: rgb(255, 64, 64);">To ensure your safety and the safety of the healthcare professionals during the COVID-19 pandemic, <strong>you are</strong> <strong>required to wear a face covering or mask that covers your mouth and nose when visiting the lab</strong>.</span><span style="color: rgb(0, 0, 86);">\u00a0</span></p><p><span style="color: rgb(0, 0, 86);"><span style="color: rgb(255, 64, 64);">If you have any issues with your testing center, please contact us at 1-800-456-2323. When you arrive at the lab, sign in with the name you provided.\u00a0</span></span><span style="color: rgb(0, 0, 0);"><strong>You DO NOT need to show your ID or give your insurance information.</strong></span></p><hr><p>As soon as your results are completed, you will receive a notification either by email or text depending on your chosen preference when you placed your order.</p><p>The time frame for taking an STD test varies based on the incubation period for the infection and can differ from person to person. Please see the following to find out the best time to take an STD test: Chlamydia 1-5 days; Gonorrhea 2-6 days; Syphilis 3-6 weeks; Hepatitis A 2-7 weeks; Hepatitis B 3-6 weeks; Hepatitis C 8-9 weeks; Herpes 1 &amp; 2 4-6 weeks; HIV 4th Generation 2-3 weeks and HIV RNA 9-11 days.</p><hr><hr><p>Additionally, please note that the charge on your bank statement will appear as "Analyte Health".</p><p>Best regards,<br>STDcheck.com</p><p><strong>IMPORTANT NOTES:</strong></p><ul><li>Since all testing sites are locally operated and have their own policies and procedures, it is important that you bring the attached lab form with you to the testing site.</li><li>All HIV RNA tests can take an additional 24-48 hours for processing and testing.</li><li>Some test codes on the requisition form include more than one test.</li><li>If you are getting tested for Chlamydia and/or Gonorrhea please be sure not to urinate 60 minutes prior to visiting the testing center.</li><li>If you have purchased a Wellness Panel you will need to fast 12 hours prior to visiting the lab.</li><li>Please disregard the physician and patient signature lines located at the bottom of your requisition. These signatures are not necessary for testing.</li><li><span id="docs-internal-guid-5c94f16d-cf18-188a-6734-b0f62ddfbc96">We understand that waiting for results can be stressful. To help, we have compiled a list of ways to stay calm in the <a href="https://www.stdcheck.com/blog/ways-stay-calm-waiting-test-results/" rel="noopener noreferrer" target="_blank">meantime</a>.</span></li></ul></body>',
    user_id: "24",
    is_read: "YES",
    read_at: "2022-07-13T21:02:47.000000Z",
    to_email: "djn17@charter.net",
    to_sms: null,
    date: "2022-02-04T17:07:12.333004Z",
    pdf_id: null,
    correspondence_id: null,
    correspondence_type: null,
    deleted_at: null,
    deleted_by: null,
    order_id: "1190315",
    encrypted_id:
      "eyJpdiI6ImlLMGp3b0tmQ2dubnFMK2lNdWpQYVE9PSIsInZhbHVlIjoiTUc0UUFucFJnYXEvZUo2VExkcUl0QT09IiwibWFjIjoiNTI1MDZjMjRkODY4MGU3MTBlMTg0NTBlZGFhOGY2MGI1NTNkZTg1MTRjZDQwOTZmZTVjZDg2MjJmYjZmNGFiNCIsInRhZyI6IiJ9",
    attachments: [
      {
        account_msg_attach_id: 2926750,
        account_msg_attach_account_msg_id: "3510563",
        account_msg_attach_filename: "1220984.pdf",
        disk: "requisitions",
        size: "100.86 KB",
        file_name: "1220984.pdf",
        encrypted_account_msg_attach_id:
          "eyJpdiI6Im5xYnd1OXlWTm9tNnc4YlorVzJORkE9PSIsInZhbHVlIjoiWGN3bHl3UjlDU3hpMkQ4UmNEbWdXZz09IiwibWFjIjoiZGU3NDU1MDVkYWJkNzNjZTJkZDQzY2E5ZmU5NTE4YTlkNzU4YjQ4YjA0MDA2NTBmNDkwOTRkMGE2N2M0YjhkMyIsInRhZyI6IiJ9",
      },
    ],
    sender: {
      users_manage_id: 24,
      users_manage_fname: "Health Labs",
      users_manage_lname: "Bot",
      users_manage_email: "support@stdcheck.com",
      users_manage_level: "user",
      users_manage_active: true,
      is_menu_visible: false,
      dose_spot_user_id: 135430,
      full_name: "Health Labs Bot",
      email: "support@stdcheck.com",
    },
    order: {
      customer_id: 1190315,
      first_name: "DAVID",
      last_name: "JONES",
      gender: "M",
      date_of_birth: "1974-05-04T00:00:00",
      result_notification_method: "Email",
      result_notification_parameter: null,
      phone: "6184062431",
      leave_message: "NO",
      send_sms: false,
      is_active: true,
      awaiting_lab_confirmation: false,
      payment_status: "Not Paid",
      transaction_id: "S5qUAMo9Y7",
      site_id: "1",
      declined_consultation: false,
      network_account_id: "18",
      trace_requested: null,
      expedite_requested: null,
      created_at: "2022-02-04T11:04:35",
      updated_at: "2022-02-04T11:07:10",
      result_status: "None",
      ip_address: "2600:6c42:7800:fefc:99a2:95ff:4b0:af43",
      created_by_id: null,
      awaiting_address_confirmation: false,
      business_account_id: null,
      kit_code: null,
      hash: "$2y$10$bwAyRC/8359CvM04fTH6mualXzzudzxBMK2Ul41W8r8fqflZWBUnO",
      account_type: "email",
      total_cost: 20800,
      total_payments: 0,
      total_pending: 0,
      consult_url: "",
      consult_url_base:
        "https://www.stdcheck.com/consultation/request?order_id=S5qUAMo9Y7",
      payment_due: true,
      status: "Active",
      requisition: {
        requisitions_id: 1220984,
        requisitions_user_id: "24",
        requisitions_message_template_id: null,
        requisitions_date_sent: "2022-02-04T17:07:10.000000Z",
        faxed_by_patient_at: null,
        source: "iLab",
        lab_order_id: "1325281566",
        deleted_at: null,
        encrypted_requisitions_id:
          "eyJpdiI6Ino5dUxxSTZHVkRBT2kxL09PZFZNNkE9PSIsInZhbHVlIjoiMXFsM2xTWTU3T3g0MTE2Uk5sdFN1dz09IiwibWFjIjoiOTJiYmE0YmM3YThjZGJkMDhjMmZkZTg0OWI3ODQxZjU2OTY5YmFkNmEwMTY5YzQ5MzIxY2U1NjUxZDkyODllYiIsInRhZyI6IiJ9",
        pdf_name: "1220984.pdf",
        fax_req: [],
      },
      can_expedite: true,
      order_style: "status-ilab",
      canGenerateRequisition: false,
      result_collection_date: null,
      patient_id: 1190315,
      sex: "M",
      race: "",
      ethnicity: "",
      sex_with: "",
      symptoms: "",
      pregnant: "",
      due_date: null,
      last_menstrual_date: null,
      address: {
        customer_address_id: 1158677,
        customer_address_customer_id: "1190315",
        customer_address_street: "12 South Ruby Lane",
        customer_address_city: "Fairview Heights",
        customer_address_state: "IL",
        customer_address_zip: "62208",
      },
      doh_data: {
        id: 1332687,
        patient_id: "1190315",
        sex: "M",
        race: null,
        ethnicity: null,
        sex_with: null,
        symptoms: "",
        pregnant: null,
        last_menstrual_date: null,
        due_date: null,
        created_at: "2022-02-04T17:04:35.000000Z",
        updated_at: "2022-02-04T17:04:35.000000Z",
        deleted_at: null,
      },
      account: {
        accounts_id: 351972,
        email: "djn17@charter.net",
        phone: null,
        type: "email",
        first_name: "David",
        last_name: "Jones",
        locked: false,
        is_active: true,
        business_account_id: null,
        created_at: "2018-12-19 22:03:16",
        updated_at: "2020-10-24 09:25:52",
        deleted_at: null,
      },
      tests: [
        {
          customer_tests_id: 2142437,
          customer_tests_type: "Individual",
          customer_tests_name: "Chlamydia",
          customer_tests_price: 5900,
          test_codes: "5399",
          cpt_code: "87491",
          customer_tests_customer_id: "1190315",
          test_id: "2",
          deleted_at: null,
          reference_id: "2026",
        },
        {
          customer_tests_id: 2142441,
          customer_tests_type: "Upsell Panel",
          customer_tests_name:
            "Trichomoniasis Test + Comprehensive Wellness Panel with a Urinalysis",
          customer_tests_price: 14900,
          test_codes: "4445; 1501; 9179; 1000",
          cpt_code: null,
          customer_tests_customer_id: "1190315",
          test_id: "1008",
          deleted_at: null,
          reference_id: null,
        },
      ],
      site: {
        id: 1,
        name: "STDcheck",
        url: "stdcheck.com",
        phone_number: "1-800-456-2323",
        merchant_id: "STDCheck",
        created_at: "2015-07-20T18:30:33.000000Z",
        updated_at: "2021-10-07T19:48:35.000000Z",
        deleted_at: null,
        icon: "stdcheck.ico",
      },
    },
  },
  {
    id: 3510562,
    title: "Fasting Required",
    content:
      '<p>Hi DAVID,</p><p>Thank you for choosing STDcheck for your laboratory testing needs. &nbsp;As a reminder, one or more of your laboratory tests requires you to fast prior to visiting the lab. &nbsp;To ensure the most accurate results, please follow the fasting instructions below. &nbsp;After visiting the lab in the morning, you can eat and drink normally again.</p><p><strong>Fasting Instructions:</strong></p><p><table width="100%" style="font-family: \'Helvetica Neue\',Helvetica,Arial,sans-serif;width:100%;border-collapse: collapse;">\n  <tr><th style="border: 1px solid #aaa;padding: 2px 5px;">Test Name</th><th style="border: 1px solid #aaa;padding: 2px 5px;">Instructions</th></tr>\n      <tr>\n      <td style="border: 1px solid #aaa;padding: 2px 5px;">Comprehensive Metabolic Panel (CMP)</td>\n      <td style="border: 1px solid #aaa;padding: 2px 5px;">Fasting is required for this lab test. You should not consume food or beverages other than water for at least 8 hours prior to visiting the lab. If you choose not to fast, it may affect your results.</td>\n    </tr>\n  </table>\n</p><p><br></p><p><strong>Your Lab:</strong></p><p>Clinical Pathology Labs</p><p>5425 W. Spring Creek Pkwy Ste 240</p><p>Plano, TX 75024</p><p>Thank you,</p><p>stdcheck.com</p><p><br></p>',
    user_id: "24",
    is_read: "NO",
    read_at: "2022-07-13T21:02:50.000000Z",
    to_email: "djn17@charter.net",
    to_sms: null,
    date: "2022-02-04T17:07:12.283792Z",
    pdf_id: null,
    correspondence_id: null,
    correspondence_type: null,
    deleted_at: null,
    deleted_by: null,
    order_id: "1190315",
    encrypted_id:
      "eyJpdiI6ImJLcm1td0MrbDQ5YWdpMzJ4TnhpZlE9PSIsInZhbHVlIjoiZ0hDOFBpR3lyQ1lPUjg2L1NMOENzdz09IiwibWFjIjoiMzc4NDc4MWE1OWQ1NmRmZDY5ZWZmZWVmN2ZiY2E1NGE3ZjQ1ZGY1MDIyYmFkOTQ1YTdlNDIxODcxNmMwMWJhZSIsInRhZyI6IiJ9",
    attachments: [],
    sender: {
      users_manage_id: 24,
      users_manage_fname: "Health Labs",
      users_manage_lname: "Bot",
      users_manage_email: "support@stdcheck.com",
      users_manage_level: "user",
      users_manage_active: true,
      is_menu_visible: false,
      dose_spot_user_id: 135430,
      full_name: "Health Labs Bot",
      email: "support@stdcheck.com",
    },
    order: {
      customer_id: 1190315,
      first_name: "DAVID",
      last_name: "JONES",
      gender: "M",
      date_of_birth: "1974-05-04T00:00:00",
      result_notification_method: "Email",
      result_notification_parameter: null,
      phone: "6184062431",
      leave_message: "NO",
      send_sms: false,
      is_active: true,
      awaiting_lab_confirmation: false,
      payment_status: "Not Paid",
      transaction_id: "S5qUAMo9Y7",
      site_id: "1",
      declined_consultation: false,
      network_account_id: "18",
      trace_requested: null,
      expedite_requested: null,
      created_at: "2022-02-04T11:04:35",
      updated_at: "2022-02-04T11:07:10",
      result_status: "None",
      ip_address: "2600:6c42:7800:fefc:99a2:95ff:4b0:af43",
      created_by_id: null,
      awaiting_address_confirmation: false,
      business_account_id: null,
      kit_code: null,
      hash: "$2y$10$OEA9fzyFsMhwkC4w7Y0UP.mb25iGVhVWWh9oIva3pu7ot3uVzoyGa",
      account_type: "email",
      total_cost: 20800,
      total_payments: 0,
      total_pending: 0,
      consult_url: "",
      consult_url_base:
        "https://www.stdcheck.com/consultation/request?order_id=S5qUAMo9Y7",
      payment_due: true,
      status: "Active",
      requisition: {
        requisitions_id: 1220984,
        requisitions_user_id: "24",
        requisitions_message_template_id: null,
        requisitions_date_sent: "2022-02-04T17:07:10.000000Z",
        faxed_by_patient_at: null,
        source: "iLab",
        lab_order_id: "1325281566",
        deleted_at: null,
        encrypted_requisitions_id:
          "eyJpdiI6Ikg4dmNMNHlpMjNUNi9KNjcwOXVNNXc9PSIsInZhbHVlIjoiclRTZUR3MXU4UENCWWN4K3VGK2didz09IiwibWFjIjoiMzE3MTExMTE1ODdhMWZlMTRmYjJjNzUyZDRkOWMzYzJhMzhjMjdhZmM1ZjE5MzMyYzQ2NGUxNTFlYzE0YjkxMyIsInRhZyI6IiJ9",
        pdf_name: "1220984.pdf",
        fax_req: [],
      },
      can_expedite: true,
      order_style: "status-ilab",
      canGenerateRequisition: false,
      result_collection_date: null,
      patient_id: 1190315,
      sex: "M",
      race: "",
      ethnicity: "",
      sex_with: "",
      symptoms: "",
      pregnant: "",
      due_date: null,
      last_menstrual_date: null,
      address: {
        customer_address_id: 1158677,
        customer_address_customer_id: "1190315",
        customer_address_street: "12 South Ruby Lane",
        customer_address_city: "Fairview Heights",
        customer_address_state: "IL",
        customer_address_zip: "62208",
      },
      doh_data: {
        id: 1332687,
        patient_id: "1190315",
        sex: "M",
        race: null,
        ethnicity: null,
        sex_with: null,
        symptoms: "",
        pregnant: null,
        last_menstrual_date: null,
        due_date: null,
        created_at: "2022-02-04T17:04:35.000000Z",
        updated_at: "2022-02-04T17:04:35.000000Z",
        deleted_at: null,
      },
      account: {
        accounts_id: 351972,
        email: "djn17@charter.net",
        phone: null,
        type: "email",
        first_name: "David",
        last_name: "Jones",
        locked: false,
        is_active: true,
        business_account_id: null,
        created_at: "2018-12-19 22:03:16",
        updated_at: "2020-10-24 09:25:52",
        deleted_at: null,
      },
      tests: [
        {
          customer_tests_id: 2142437,
          customer_tests_type: "Individual",
          customer_tests_name: "Chlamydia",
          customer_tests_price: 5900,
          test_codes: "5399",
          cpt_code: "87491",
          customer_tests_customer_id: "1190315",
          test_id: "2",
          deleted_at: null,
          reference_id: "2026",
        },
        {
          customer_tests_id: 2142441,
          customer_tests_type: "Upsell Panel",
          customer_tests_name:
            "Trichomoniasis Test + Comprehensive Wellness Panel with a Urinalysis",
          customer_tests_price: 14900,
          test_codes: "4445; 1501; 9179; 1000",
          cpt_code: null,
          customer_tests_customer_id: "1190315",
          test_id: "1008",
          deleted_at: null,
          reference_id: null,
        },
      ],
      site: {
        id: 1,
        name: "STDcheck",
        url: "stdcheck.com",
        phone_number: "1-800-456-2323",
        merchant_id: "STDCheck",
        created_at: "2015-07-20T18:30:33.000000Z",
        updated_at: "2021-10-07T19:48:35.000000Z",
        deleted_at: null,
        icon: "stdcheck.ico",
      },
    },
  },
  {
    id: 2417374,
    title: "Test Confirmation",
    content:
      '<body><p>DAVID,</p><p>Thank you for choosing STDcheck for your testing needs. \u00a0Your order ID number is: POWNmtPta8.</p><p>We have attached a form that you will need to take with you when you visit the lab. You can print the attachment out or fax it directly to the lab from the <strong>My Orders</strong> tab in your online account. \u00a0As soon as your results are completed, you will receive a notification either by email or text depending on your chosen preference when you placed your order.</p><p>You can visit the lab at your earliest convenience within the lab\u2019s business hours. Appointments aren\u2019t required but can be made by calling the lab directly. You may visit any Edward-Elmhurst Laboratories facility of your choice. To find a nearby Edward-Elmhurst Laboratories location please <a href="" rel="noopener noreferrer" target="_blank">click here</a>.\u00a0</p><p><span style="color: rgb(255, 64, 64);">To ensure your safety and the safety of the healthcare professionals during the COVID-19 pandemic, <strong>you are</strong> <strong>required to wear a face covering or mask that covers your mouth and nose when visiting the lab</strong>.</span><span style="color: rgb(0, 0, 86);">\u00a0</span></p><p>The time frame for taking an STD test varies based on the incubation period for the infection and can differ from person to person. Please see the following to find out the best time to take an STD test: Chlamydia 1-5 days; Gonorrhea 2-6 days; Syphilis 3-6 weeks; Hepatitis A 2-7 weeks; Hepatitis B 3-6 weeks; Hepatitis C 8-9 weeks; Herpes 1 &amp; 2 4-6 weeks; HIV 4th Generation 2-3 weeks and HIV RNA 9-11 days.</p><p>If you have any issues with your testing center, please contact us at 1-800-456-2323. When you arrive at the lab, sign in with the name you provided. <strong>You DO NOT need to show your ID or give your insurance information; if you are asked to, please refer them to the first page of your requisition.</strong></p><p>Additionally, please note that the charge on your bank statement will appear as "HealthLabs.com".</p><p>Best regards,<br>STDcheck.com</p><p><strong>IMPORTANT NOTES:</strong></p><ul><li>All HIV RNA tests can take an additional 24-48 hours for processing and testing.</li><li>Some test codes on the requisition form include more than one test.</li><li>If you are getting tested for Chlamydia and/or Gonorrhea please be sure not to urinate 60 minutes prior to visiting the testing center.</li><li>If you have purchased a Wellness Panel you will need to fast 12 hours prior to visiting the lab.</li><li>Please disregard the physician and patient signature lines located at the bottom of your requisition. These signatures are not necessary for testing.</li><li><span id="docs-internal-guid-5c94f16d-cf18-188a-6734-b0f62ddfbc96">We understand that waiting for results can be stressful. To help, we have compiled a list of ways to stay calm in the <a href="https://www.stdcheck.com/blog/ways-stay-calm-waiting-test-results/" rel="noopener noreferrer" target="_blank">meantime</a>.</span></li></ul></body>',
    user_id: "56",
    is_read: "NO",
    read_at: "2021-06-25T23:07:42.000000Z",
    to_email: "djn17@charter.net",
    to_sms: null,
    date: "2021-01-20T16:06:39.407355Z",
    pdf_id: null,
    correspondence_id: null,
    correspondence_type: null,
    deleted_at: null,
    deleted_by: null,
    order_id: "912176",
    encrypted_id:
      "eyJpdiI6IjNHakRNWk5ESStQbEJ5dGEwdUpBNGc9PSIsInZhbHVlIjoiUXplelBIRWtONUhaQlFVNFRmV1NHZz09IiwibWFjIjoiMjIwZTE5OTRjY2NhZmMyODliOWE5OWRmNmU3YTU2MGQwZjRkZTQ3MWFhMWI0MTExOWJjZWNhZDEyZDQxZDU1OCIsInRhZyI6IiJ9",
    attachments: [
      {
        account_msg_attach_id: 2028309,
        account_msg_attach_account_msg_id: "2417374",
        account_msg_attach_filename: "933018.pdf",
        disk: "requisitions",
        size: "163.83 KB",
        file_name: "933018.pdf",
        encrypted_account_msg_attach_id:
          "eyJpdiI6IkNheG9TczBaYmRJWE9KZlBFUzhGRGc9PSIsInZhbHVlIjoiS3NLenZUWVh3RjMrcFpKWUlqL3JjUT09IiwibWFjIjoiN2JhOTJkMGM5ZjU3MmU0ZDQ4MWRlZDdiYTA5NWRiZTc4OTdjMWMwMjU1ZGEzZGExZjkwNDkyMTFlODQ0MTljNiIsInRhZyI6IiJ9",
      },
    ],
    sender: {
      users_manage_id: 56,
      users_manage_fname: "Jasmine",
      users_manage_lname: "Davis",
      users_manage_email: "jasmine@healthlabs.com",
      users_manage_level: "user",
      users_manage_active: true,
      is_menu_visible: true,
      dose_spot_user_id: 139607,
      full_name: "Jasmine Davis",
      email: "jasmine@healthlabs.com",
    },
    order: {
      customer_id: 912176,
      first_name: "DAVID",
      last_name: "JONES",
      gender: "M",
      date_of_birth: "1974-05-04T00:00:00",
      result_notification_method: "Email",
      result_notification_parameter: null,
      phone: "6184062431",
      leave_message: "NO",
      send_sms: false,
      is_active: true,
      awaiting_lab_confirmation: false,
      payment_status: "Not Paid",
      transaction_id: "POWNmtPta8",
      site_id: "1",
      declined_consultation: false,
      network_account_id: null,
      trace_requested: null,
      expedite_requested: null,
      created_at: "2021-01-20T07:49:13",
      updated_at: "2021-01-20T10:05:01",
      result_status: "None",
      ip_address: "2600:6c42:7800:f87:9d45:4876:c3ad:ea81",
      created_by_id: null,
      awaiting_address_confirmation: false,
      business_account_id: null,
      kit_code: null,
      hash: "$2y$10$nDFG6zzgRUerGdbjhVaIvuBfMzWJ.aeUTH/Xa/ekzozJf5LtB.IXO",
      account_type: "email",
      total_cost: 5900,
      total_payments: 0,
      total_pending: 0,
      consult_url: "",
      consult_url_base:
        "https://www.stdcheck.com/consultation/request?order_id=POWNmtPta8",
      payment_due: true,
      status: "Active",
      requisition: {
        requisitions_id: 933018,
        requisitions_user_id: "56",
        requisitions_message_template_id: null,
        requisitions_date_sent: "2021-01-20T16:06:23.000000Z",
        faxed_by_patient_at: "2021-11-04T21:37:05.000000Z",
        source: "Manual Upload",
        lab_order_id: "1324839131",
        deleted_at: null,
        encrypted_requisitions_id:
          "eyJpdiI6ImVCVzd0aHc2T09wT25GcloxaUs4L1E9PSIsInZhbHVlIjoiTVFFbkNXNE1kblpzaUgyNmQzSUtKUT09IiwibWFjIjoiZmJmMWNiOWJkMjk0YWExZjQ0OTFkODY2ZTFkZjdiMzJiZGU3OTRmZTFkNzVhY2UyY2JjOWUwZDgzMDcxYjViNiIsInRhZyI6IiJ9",
        pdf_name: "933018.pdf",
        fax_req: [
          {
            fax_req_id: 310129,
            fax_req_requisition_id: "933018",
            fax_req_user_id: "56",
            fax_req_date_sent: "2021-01-20 10:06:32",
            fax_req_number: "8334318572",
            fax_req_status: "delivered",
            fax_req_sid: "FX1f397d8b6900116641c89a507c230bd3",
          },
          {
            fax_req_id: 419939,
            fax_req_requisition_id: "933018",
            fax_req_user_id: "24",
            fax_req_date_sent: "2021-11-04 16:37:05",
            fax_req_number: "8334318572",
            fax_req_status: "delivered",
            fax_req_sid: "3e76bbc2-8a79-4afa-a067-33511491c0e5",
          },
        ],
      },
      can_expedite: true,
      order_style: "status-reqsent",
      canGenerateRequisition: false,
      result_collection_date: null,
      patient_id: 912176,
      sex: "M",
      race: "",
      ethnicity: "",
      sex_with: "",
      symptoms: "",
      pregnant: "",
      due_date: null,
      last_menstrual_date: null,
      address: {
        customer_address_id: 891516,
        customer_address_customer_id: "912176",
        customer_address_street: "12 South Ruby Lane",
        customer_address_city: "Fairview Heights",
        customer_address_state: "IL",
        customer_address_zip: "62208",
      },
      doh_data: {
        id: 1054549,
        patient_id: "912176",
        sex: "M",
        race: null,
        ethnicity: null,
        sex_with: null,
        symptoms: "",
        pregnant: null,
        last_menstrual_date: null,
        due_date: null,
        created_at: "2021-01-20T13:49:13.000000Z",
        updated_at: "2021-01-20T13:49:13.000000Z",
        deleted_at: null,
      },
      account: {
        accounts_id: 351972,
        email: "djn17@charter.net",
        phone: null,
        type: "email",
        first_name: "David",
        last_name: "Jones",
        locked: false,
        is_active: true,
        business_account_id: null,
        created_at: "2018-12-19 22:03:16",
        updated_at: "2020-10-24 09:25:52",
        deleted_at: null,
      },
      tests: [
        {
          customer_tests_id: 1628929,
          customer_tests_type: "Individual",
          customer_tests_name: "Chlamydia",
          customer_tests_price: 5900,
          test_codes: "30600074",
          cpt_code: "87491",
          customer_tests_customer_id: "912176",
          test_id: "2",
          deleted_at: null,
          reference_id: "2026",
        },
      ],
      site: {
        id: 1,
        name: "STDcheck",
        url: "stdcheck.com",
        phone_number: "1-800-456-2323",
        merchant_id: "STDCheck",
        created_at: "2015-07-20T18:30:33.000000Z",
        updated_at: "2021-10-07T19:48:35.000000Z",
        deleted_at: null,
        icon: "stdcheck.ico",
      },
    },
  },
  {
    id: 2267738,
    title: "Test Confirmation",
    content:
      '<body><p>DAVID,</p><p>Thank you for choosing STDcheck for your testing needs. \u00a0Your order ID number is: 7od6V1iXki.</p><p>We have attached a form that you will need to take with you when you visit the lab. You can print the attachment out or fax it directly to the lab from the <strong>My Orders</strong> tab in your online account. \u00a0As soon as your results are completed, you will receive a notification either by email or text depending on your chosen preference when you placed your order.</p><p>You may visit any Quest facility of your choice. To find a nearby Quest location please <a href="https://appointment.questdiagnostics.com/patient/appointment" rel="noopener noreferrer" target="_blank">click here</a>.\u00a0</p><p><span style="color: rgb(255, 64, 64);">To ensure your safety and the safety of the healthcare professionals during the COVID-19 pandemic, <strong>you are</strong> <strong>required to wear a face covering or mask that covers your mouth and nose when visiting the lab</strong>.</span><span style="color: rgb(0, 0, 86);">\u00a0</span></p><p>The time frame for taking an STD test varies based on the incubation period for the infection and can differ from person to person. Please see the following to find out the best time to take an STD test: Chlamydia 1-5 days; Gonorrhea 2-6 days; Syphilis 3-6 weeks; Hepatitis A 2-7 weeks; Hepatitis B 3-6 weeks; Hepatitis C 8-9 weeks; Herpes 1 &amp; 2 4-6 weeks; HIV 4th Generation 2-3 weeks and HIV RNA 9-11 days.</p><p>If you have any issues with your testing center, please contact us at 1-800-456-2323. When you arrive at the lab, sign in with the name you provided. <strong>You DO NOT need to show your ID or give your insurance information; if you are asked to, please refer them to the first page of your requisition.</strong></p><p>Additionally, please note that the charge on your bank statement will appear as "HealthLabs.com".</p><p>Best regards,<br>STDcheck.com</p><p><strong>IMPORTANT NOTES:</strong></p><ul><li>All HIV RNA tests can take an additional 24-48 hours for processing and testing.</li><li>Some test codes on the requisition form include more than one test.</li><li>If you are getting tested for Chlamydia and/or Gonorrhea please be sure not to urinate 60 minutes prior to visiting the testing center.</li><li>If you have purchased a Wellness Panel you will need to fast 12 hours prior to visiting the lab.</li><li>Please disregard the physician and patient signature lines located at the bottom of your requisition. These signatures are not necessary for testing.</li><li><span id="docs-internal-guid-5c94f16d-cf18-188a-6734-b0f62ddfbc96">We understand that waiting for results can be stressful. To help, we have compiled a list of ways to stay calm in the <a href="https://www.stdcheck.com/blog/ways-stay-calm-waiting-test-results/" rel="noopener noreferrer" target="_blank">meantime</a>.</span></li></ul></body>',
    user_id: "24",
    is_read: "YES",
    read_at: "2020-10-24T14:29:29.000000Z",
    to_email: "djn17@charter.net",
    to_sms: null,
    date: "2020-10-24T14:27:13.069780Z",
    pdf_id: null,
    correspondence_id: null,
    correspondence_type: null,
    deleted_at: null,
    deleted_by: null,
    order_id: "865558",
    encrypted_id:
      "eyJpdiI6IlNMTTlnZmN2TUs1UG1Uc2ViZmc0SFE9PSIsInZhbHVlIjoiamxIZmpDaS95UC9VcUVqOXBJUjdXQT09IiwibWFjIjoiM2UxZmEzOTc2NDkwODU4NmQ2NGRmMzdjZWUwMWNjODQyODExOTUzMzA2ODMzNDhhYTcwZjIxOTY0ZmQ1YjNiYyIsInRhZyI6IiJ9",
    attachments: [
      {
        account_msg_attach_id: 1911189,
        account_msg_attach_account_msg_id: "2267738",
        account_msg_attach_filename: "884496.pdf",
        disk: "requisitions",
        size: "103.00 KB",
        file_name: "884496.pdf",
        encrypted_account_msg_attach_id:
          "eyJpdiI6Ikx2ZlJQYVBJb2NibXFuS1ZjaXRrM0E9PSIsInZhbHVlIjoiUVJXd21yNkxRdzNPZXVQNjdNS2VwUT09IiwibWFjIjoiYjk1NjdjYjhkMTczNzAyMzc4YTZlMGM1Y2MzMDY3OWZlZjYxMjllZjQzMGZmZDFjZjNjY2ExOGE0MGEwZWFjOCIsInRhZyI6IiJ9",
      },
    ],
    sender: {
      users_manage_id: 24,
      users_manage_fname: "Health Labs",
      users_manage_lname: "Bot",
      users_manage_email: "support@stdcheck.com",
      users_manage_level: "user",
      users_manage_active: true,
      is_menu_visible: false,
      dose_spot_user_id: 135430,
      full_name: "Health Labs Bot",
      email: "support@stdcheck.com",
    },
    order: {
      customer_id: 865558,
      first_name: "DAVID",
      last_name: "JONES",
      gender: "M",
      date_of_birth: "1974-05-04T00:00:00",
      result_notification_method: "Email",
      result_notification_parameter: null,
      phone: "6184072431",
      leave_message: "NO",
      send_sms: false,
      is_active: true,
      awaiting_lab_confirmation: false,
      payment_status: "Not Paid",
      transaction_id: "7od6V1iXki",
      site_id: "1",
      declined_consultation: false,
      network_account_id: null,
      trace_requested: null,
      expedite_requested: null,
      created_at: "2020-10-24T09:25:52",
      updated_at: "2020-10-24T09:27:09",
      result_status: "None",
      ip_address: "75.132.172.144",
      created_by_id: null,
      awaiting_address_confirmation: false,
      business_account_id: null,
      kit_code: null,
      hash: "$2y$10$7rHHBCq1TdOltXqteZapzu.bF1XerEUIZsXV9XD6JtVDR2WXk2txC",
      account_type: "email",
      total_cost: 49800,
      total_payments: 0,
      total_pending: 0,
      consult_url: "",
      consult_url_base:
        "https://www.stdcheck.com/consultation/request?order_id=7od6V1iXki",
      payment_due: true,
      status: "Active",
      requisition: {
        requisitions_id: 884496,
        requisitions_user_id: "24",
        requisitions_message_template_id: null,
        requisitions_date_sent: "2020-10-24T14:27:12.000000Z",
        faxed_by_patient_at: "2021-11-30T16:30:48.000000Z",
        source: "Medivo",
        lab_order_id: "1324764004",
        deleted_at: null,
        encrypted_requisitions_id:
          "eyJpdiI6Ill0L0d5d2dGeFM0cENaNUw1eUc2OWc9PSIsInZhbHVlIjoiREVReG8zOVhNK1Y3MnhUeEo1SFNnUT09IiwibWFjIjoiZTQ4ZWIzM2FlODU0MWNmNjFjMDVjZmYyZWM5MDc4MjViYTlhYjIzOGI1YmVlYzA5MjNlZmFkYWJiYWQ4YWE5NyIsInRhZyI6IiJ9",
        pdf_name: "884496.pdf",
        fax_req: [
          {
            fax_req_id: 382639,
            fax_req_requisition_id: "884496",
            fax_req_user_id: "24",
            fax_req_date_sent: "2021-08-06 12:09:39",
            fax_req_number: "3123327672",
            fax_req_status: "delivered",
            fax_req_sid: "d2654350-66d3-49d8-97cb-2a0162556b21",
          },
          {
            fax_req_id: 419941,
            fax_req_requisition_id: "884496",
            fax_req_user_id: "24",
            fax_req_date_sent: "2021-11-04 16:38:26",
            fax_req_number: "3123327672",
            fax_req_status: "delivered",
            fax_req_sid: "d376e8f8-2e06-489f-9c7c-ed89d978da42",
          },
          {
            fax_req_id: 428837,
            fax_req_requisition_id: "884496",
            fax_req_user_id: "24",
            fax_req_date_sent: "2021-11-30 10:30:48",
            fax_req_number: "3123327672",
            fax_req_status: "busy",
            fax_req_sid: "0db987b6-5520-4b77-bc5e-4d1b5a997d12",
          },
          {
            fax_req_id: 428838,
            fax_req_requisition_id: "884496",
            fax_req_user_id: "24",
            fax_req_date_sent: "2021-11-30 10:30:49",
            fax_req_number: "3123327672",
            fax_req_status: "delivered",
            fax_req_sid: "ed2574dd-99c3-4851-a0e2-f8dcd3651e97",
          },
        ],
      },
      can_expedite: true,
      order_style: "status-medivo",
      canGenerateRequisition: false,
      result_collection_date: null,
      patient_id: 865558,
      sex: "M",
      race: "",
      ethnicity: "",
      sex_with: "",
      symptoms: "",
      pregnant: "",
      due_date: null,
      last_menstrual_date: null,
      address: {
        customer_address_id: 846066,
        customer_address_customer_id: "865558",
        customer_address_street: "12 South Ruby Lane",
        customer_address_city: "Fairview Heights",
        customer_address_state: "IL",
        customer_address_zip: "62208",
      },
      doh_data: {
        id: 1007931,
        patient_id: "865558",
        sex: "M",
        race: null,
        ethnicity: null,
        sex_with: null,
        symptoms: "",
        pregnant: null,
        last_menstrual_date: null,
        due_date: null,
        created_at: "2020-10-24T14:25:52.000000Z",
        updated_at: "2020-10-24T14:25:52.000000Z",
        deleted_at: null,
      },
      account: {
        accounts_id: 351972,
        email: "djn17@charter.net",
        phone: null,
        type: "email",
        first_name: "David",
        last_name: "Jones",
        locked: false,
        is_active: true,
        business_account_id: null,
        created_at: "2018-12-19 22:03:16",
        updated_at: "2020-10-24 09:25:52",
        deleted_at: null,
      },
      tests: [
        {
          customer_tests_id: 1538969,
          customer_tests_type: "Panel",
          customer_tests_name: "10 Test Panel with HIV RNA Early Detection",
          customer_tests_price: 34900,
          test_codes: "512; 498; 8472; 36126; 16185; 11363; 3636; 3640",
          cpt_code: null,
          customer_tests_customer_id: "865558",
          test_id: "1004",
          deleted_at: null,
          reference_id: null,
        },
        {
          customer_tests_id: 1538970,
          customer_tests_type: "Upsell Panel",
          customer_tests_name:
            "Trichomoniasis Test + Comprehensive Wellness Panel with a Urinalysis",
          customer_tests_price: 14900,
          test_codes: "90801; 5463; 10231; 6399",
          cpt_code: null,
          customer_tests_customer_id: "865558",
          test_id: "1008",
          deleted_at: null,
          reference_id: null,
        },
      ],
      site: {
        id: 1,
        name: "STDcheck",
        url: "stdcheck.com",
        phone_number: "1-800-456-2323",
        merchant_id: "STDCheck",
        created_at: "2015-07-20T18:30:33.000000Z",
        updated_at: "2021-10-07T19:48:35.000000Z",
        deleted_at: null,
        icon: "stdcheck.ico",
      },
    },
  },
  {
    id: 2267737,
    title: "Fasting Required",
    content:
      '<p>Hi DAVID,</p><p>Thank you for choosing STDcheck for your laboratory testing needs. &nbsp;As a reminder, one or more of your laboratory tests requires you to fast prior to visiting the lab. &nbsp;To ensure the most accurate results, please follow the fasting instructions below. &nbsp;After visiting the lab in the morning, you can eat and drink normally again.</p><p><strong>Fasting Instructions:</strong></p><p><table width="100%" style="font-family: \'Helvetica Neue\',Helvetica,Arial,sans-serif;width:100%;border-collapse: collapse;">\n  <tr><th style="border: 1px solid #aaa;padding: 2px 5px;">Test Name</th><th style="border: 1px solid #aaa;padding: 2px 5px;">Instructions</th></tr>\n      <tr>\n      <td style="border: 1px solid #aaa;padding: 2px 5px;">Comprehensive Metabolic Panel (CMP)</td>\n      <td style="border: 1px solid #aaa;padding: 2px 5px;">Fasting is required for this lab test. You should not consume food or beverages other than water for at least 8 hours prior to visiting the lab. If you choose not to fast, it may affect your results.</td>\n    </tr>\n  </table>\n</p><p><br></p><p><strong>Your Lab:</strong></p><p>Quest Diagnostics</p><p>111 N Wabash Ave, Ste 1514</p><p>Chicago, IL 60602</p><p>Thank you,</p><p>stdcheck.com</p><p><br></p>',
    user_id: "24",
    is_read: "YES",
    read_at: "2021-08-06T17:11:19.000000Z",
    to_email: "djn17@charter.net",
    to_sms: null,
    date: "2020-10-24T14:27:09.531060Z",
    pdf_id: null,
    correspondence_id: null,
    correspondence_type: null,
    deleted_at: null,
    deleted_by: null,
    order_id: "865558",
    encrypted_id:
      "eyJpdiI6IjgyL1dMQjh1Z0p6OEd0YjZoSllDSUE9PSIsInZhbHVlIjoiMlNYVHZBZHo1Y1NoMHdoRFpsWkMzZz09IiwibWFjIjoiOTI1YjRiN2I3NzNiM2QwZWI5OGY5NGVjYTgxMmY0NTk0ODNlNjU0MjVhMzU2YjYyMGY2NjdmYzFmYTc3ZDk1OSIsInRhZyI6IiJ9",
    attachments: [],
    sender: {
      users_manage_id: 24,
      users_manage_fname: "Health Labs",
      users_manage_lname: "Bot",
      users_manage_email: "support@stdcheck.com",
      users_manage_level: "user",
      users_manage_active: true,
      is_menu_visible: false,
      dose_spot_user_id: 135430,
      full_name: "Health Labs Bot",
      email: "support@stdcheck.com",
    },
    order: {
      customer_id: 865558,
      first_name: "DAVID",
      last_name: "JONES",
      gender: "M",
      date_of_birth: "1974-05-04T00:00:00",
      result_notification_method: "Email",
      result_notification_parameter: null,
      phone: "6184072431",
      leave_message: "NO",
      send_sms: false,
      is_active: true,
      awaiting_lab_confirmation: false,
      payment_status: "Not Paid",
      transaction_id: "7od6V1iXki",
      site_id: "1",
      declined_consultation: false,
      network_account_id: null,
      trace_requested: null,
      expedite_requested: null,
      created_at: "2020-10-24T09:25:52",
      updated_at: "2020-10-24T09:27:09",
      result_status: "None",
      ip_address: "75.132.172.144",
      created_by_id: null,
      awaiting_address_confirmation: false,
      business_account_id: null,
      kit_code: null,
      hash: "$2y$10$BVa7i41a08FjF/K4HBFideX9ZbUMneESLJ5qfgr5v8KtHci8KW60i",
      account_type: "email",
      total_cost: 49800,
      total_payments: 0,
      total_pending: 0,
      consult_url: "",
      consult_url_base:
        "https://www.stdcheck.com/consultation/request?order_id=7od6V1iXki",
      payment_due: true,
      status: "Active",
      requisition: {
        requisitions_id: 884496,
        requisitions_user_id: "24",
        requisitions_message_template_id: null,
        requisitions_date_sent: "2020-10-24T14:27:12.000000Z",
        faxed_by_patient_at: "2021-11-30T16:30:48.000000Z",
        source: "Medivo",
        lab_order_id: "1324764004",
        deleted_at: null,
        encrypted_requisitions_id:
          "eyJpdiI6ImdISlp1bWkrUi9QTVFuOGhTUXMrK3c9PSIsInZhbHVlIjoiRTVOcDByQ2pCeFdkby9zd1RlRllqUT09IiwibWFjIjoiMzY3M2YxZTk5MTk1OWNjMjlkYWFjMTYwYjlkZDk0OTZhMmY1ZWI2ZDEyNDFlYzhlZmZhZTU4ZmVlNGVjM2VmMyIsInRhZyI6IiJ9",
        pdf_name: "884496.pdf",
        fax_req: [
          {
            fax_req_id: 382639,
            fax_req_requisition_id: "884496",
            fax_req_user_id: "24",
            fax_req_date_sent: "2021-08-06 12:09:39",
            fax_req_number: "3123327672",
            fax_req_status: "delivered",
            fax_req_sid: "d2654350-66d3-49d8-97cb-2a0162556b21",
          },
          {
            fax_req_id: 419941,
            fax_req_requisition_id: "884496",
            fax_req_user_id: "24",
            fax_req_date_sent: "2021-11-04 16:38:26",
            fax_req_number: "3123327672",
            fax_req_status: "delivered",
            fax_req_sid: "d376e8f8-2e06-489f-9c7c-ed89d978da42",
          },
          {
            fax_req_id: 428837,
            fax_req_requisition_id: "884496",
            fax_req_user_id: "24",
            fax_req_date_sent: "2021-11-30 10:30:48",
            fax_req_number: "3123327672",
            fax_req_status: "busy",
            fax_req_sid: "0db987b6-5520-4b77-bc5e-4d1b5a997d12",
          },
          {
            fax_req_id: 428838,
            fax_req_requisition_id: "884496",
            fax_req_user_id: "24",
            fax_req_date_sent: "2021-11-30 10:30:49",
            fax_req_number: "3123327672",
            fax_req_status: "delivered",
            fax_req_sid: "ed2574dd-99c3-4851-a0e2-f8dcd3651e97",
          },
        ],
      },
      can_expedite: true,
      order_style: "status-medivo",
      canGenerateRequisition: false,
      result_collection_date: null,
      patient_id: 865558,
      sex: "M",
      race: "",
      ethnicity: "",
      sex_with: "",
      symptoms: "",
      pregnant: "",
      due_date: null,
      last_menstrual_date: null,
      address: {
        customer_address_id: 846066,
        customer_address_customer_id: "865558",
        customer_address_street: "12 South Ruby Lane",
        customer_address_city: "Fairview Heights",
        customer_address_state: "IL",
        customer_address_zip: "62208",
      },
      doh_data: {
        id: 1007931,
        patient_id: "865558",
        sex: "M",
        race: null,
        ethnicity: null,
        sex_with: null,
        symptoms: "",
        pregnant: null,
        last_menstrual_date: null,
        due_date: null,
        created_at: "2020-10-24T14:25:52.000000Z",
        updated_at: "2020-10-24T14:25:52.000000Z",
        deleted_at: null,
      },
      account: {
        accounts_id: 351972,
        email: "djn17@charter.net",
        phone: null,
        type: "email",
        first_name: "David",
        last_name: "Jones",
        locked: false,
        is_active: true,
        business_account_id: null,
        created_at: "2018-12-19 22:03:16",
        updated_at: "2020-10-24 09:25:52",
        deleted_at: null,
      },
      tests: [
        {
          customer_tests_id: 1538969,
          customer_tests_type: "Panel",
          customer_tests_name: "10 Test Panel with HIV RNA Early Detection",
          customer_tests_price: 34900,
          test_codes: "512; 498; 8472; 36126; 16185; 11363; 3636; 3640",
          cpt_code: null,
          customer_tests_customer_id: "865558",
          test_id: "1004",
          deleted_at: null,
          reference_id: null,
        },
        {
          customer_tests_id: 1538970,
          customer_tests_type: "Upsell Panel",
          customer_tests_name:
            "Trichomoniasis Test + Comprehensive Wellness Panel with a Urinalysis",
          customer_tests_price: 14900,
          test_codes: "90801; 5463; 10231; 6399",
          cpt_code: null,
          customer_tests_customer_id: "865558",
          test_id: "1008",
          deleted_at: null,
          reference_id: null,
        },
      ],
      site: {
        id: 1,
        name: "STDcheck",
        url: "stdcheck.com",
        phone_number: "1-800-456-2323",
        merchant_id: "STDCheck",
        created_at: "2015-07-20T18:30:33.000000Z",
        updated_at: "2021-10-07T19:48:35.000000Z",
        deleted_at: null,
        icon: "stdcheck.ico",
      },
    },
  },
  {
    id: 1862752,
    title: "Test Confirmation",
    content:
      '<body><p>DAVID,</p><p>Thank you for choosing STDcheck for your testing needs. \u00a0Your order ID number is: 05OEnr4yKH.</p><p>We have attached a form that you will need to take with you when you visit the lab. You can print the attachment out or fax it directly to the lab from the <strong>My Orders</strong> tab in your online account. \u00a0As soon as your results are completed, you will receive a notification either by email or text depending on your chosen preference when you placed your order.</p><p><strong>You selected this lab location:</strong></p><p style="line-height: 1;">Labcorp</p><p style="line-height: 1;">713 Omaha St</p><p style="line-height: 1;">Rapid City, SD 57701</p><p>The time frame for taking an STD test varies based on the incubation period for the infection and can differ from person to person. Please see the following to find out the best time to take an STD test: Chlamydia 1-5 days; Gonorrhea 2-6 days; Syphilis 3-6 weeks; Hepatitis A 2-7 weeks; Hepatitis B 3-6 weeks; Hepatitis C 8-9 weeks; Herpes 1 &amp; 2 4-6 weeks; HIV 4th Generation 2-3 weeks and HIV RNA 9-11 days.</p><p>If you have any issues with your testing center, please contact us at 1-800-456-2323. When you arrive at the lab, sign in with the name you provided. <strong>You DO NOT need to show your ID or give your insurance information; if you are asked to, please refer them to the first page of your requisition.</strong></p><p>Additionally, please note that the charge on your bank statement will appear as "HealthLabs.com".</p><p>Best regards,<br>STDcheck.com</p><p><strong>IMPORTANT NOTES:</strong></p><ul><li>All HIV RNA tests can take an additional 24-48 hours for processing and testing.</li><li>Some test codes on the requisition form include more than one test.</li><li>If you are getting tested for Chlamydia and/or Gonorrhea please be sure not to urinate 60 minutes prior to visiting the testing center.</li><li>If you have purchased a Wellness Panel you will need to fast 12 hours prior to visiting the lab.</li><li>Please disregard the physician and patient signature lines located at the bottom of your requisition. These signatures are not necessary for testing.</li><li><span id="docs-internal-guid-5c94f16d-cf18-188a-6734-b0f62ddfbc96">We understand that waiting for results can be stressful. To help, we have compiled a list of ways to stay calm in the <a href="https://www.stdcheck.com/blog/ways-stay-calm-waiting-test-results/" rel="noopener noreferrer" target="_blank">meantime</a>.</span></li></ul></body>',
    user_id: "24",
    is_read: "YES",
    read_at: "2020-07-08T13:28:00.000000Z",
    to_email: "djn17@charter.net",
    to_sms: null,
    date: "2020-04-16T01:29:44.544452Z",
    pdf_id: null,
    correspondence_id: null,
    correspondence_type: null,
    deleted_at: null,
    deleted_by: null,
    order_id: "732087",
    encrypted_id:
      "eyJpdiI6IkNKdEJVaGJoVENlRURtVjNSdTJLQ2c9PSIsInZhbHVlIjoiMWtoaW4xMEtVZGVOSHl5ZE9rZUNOQT09IiwibWFjIjoiOTcxZGJlZGQ5NzA0MDg3OWE0MzViMjU3Yjg4MWYwYWI5MzcxZTY2ZDJlYzY1MWYxODllOGZiOTk5MDI0ZTMzOCIsInRhZyI6IiJ9",
    attachments: [
      {
        account_msg_attach_id: 1571231,
        account_msg_attach_account_msg_id: "1862752",
        account_msg_attach_filename: "745973.pdf",
        disk: "requisitions",
        size: "137.02 KB",
        file_name: "745973.pdf",
        encrypted_account_msg_attach_id:
          "eyJpdiI6IlhoRHB6Y0xLWFZKeXdqOXRKRlNua1E9PSIsInZhbHVlIjoiR1kvSmlGSUdkOW04MVdLZzltVGVMQT09IiwibWFjIjoiMmI0NjQxYWJjYjY0YjI5ZDY0NTUzZDlkOGM2NDMwOTI0MTM5YmJhZjE0OWRhOWE5ZDcwNDllZmE0M2ZlNTBjNSIsInRhZyI6IiJ9",
      },
    ],
    sender: {
      users_manage_id: 24,
      users_manage_fname: "Health Labs",
      users_manage_lname: "Bot",
      users_manage_email: "support@stdcheck.com",
      users_manage_level: "user",
      users_manage_active: true,
      is_menu_visible: false,
      dose_spot_user_id: 135430,
      full_name: "Health Labs Bot",
      email: "support@stdcheck.com",
    },
    order: {
      customer_id: 732087,
      first_name: "DAVID",
      last_name: "GWINN",
      gender: "M",
      date_of_birth: "1982-03-11T00:00:00",
      result_notification_method: "Email",
      result_notification_parameter: null,
      phone: "",
      leave_message: "NO",
      send_sms: false,
      is_active: true,
      awaiting_lab_confirmation: false,
      payment_status: "Not Paid",
      transaction_id: "05OEnr4yKH",
      site_id: "1",
      declined_consultation: false,
      network_account_id: "1",
      trace_requested: null,
      expedite_requested: null,
      created_at: "2020-04-15T19:59:40",
      updated_at: "2020-04-15T20:29:41",
      result_status: "None",
      ip_address: "75.132.172.144",
      created_by_id: null,
      awaiting_address_confirmation: false,
      business_account_id: null,
      kit_code: null,
      hash: "$2y$10$1Y0UtpsjSqdIthEfx1HkQ.dKyrJTVIP2O1dIfr4W.oyqf01dTttvK",
      account_type: "email",
      total_cost: 34900,
      total_payments: 0,
      total_pending: 0,
      consult_url: "",
      consult_url_base:
        "https://www.stdcheck.com/consultation/request?order_id=05OEnr4yKH",
      payment_due: true,
      status: "Active",
      requisition: {
        requisitions_id: 745973,
        requisitions_user_id: "24",
        requisitions_message_template_id: null,
        requisitions_date_sent: "2020-04-16T01:29:43.000000Z",
        faxed_by_patient_at: "2021-04-16T13:37:07.000000Z",
        source: "Medivo",
        lab_order_id: "1324602979",
        deleted_at: null,
        encrypted_requisitions_id:
          "eyJpdiI6Imt5Skx1S3I4dFAyZCtNdnQ1MGgvUHc9PSIsInZhbHVlIjoieDRPVVNHWVFSejZsczQ4ZUExbjlndz09IiwibWFjIjoiY2JmZWQ3MGJjYmZhZDc3ZTc0ODEzYWFlNjA5ZDNhMzE2ZDYzNTVmMDlhMDY0YzhlNmEzYjllYTM3YTUzOGVmNiIsInRhZyI6IiJ9",
        pdf_name: "745973.pdf",
        fax_req: [
          {
            fax_req_id: 338325,
            fax_req_requisition_id: "745973",
            fax_req_user_id: "24",
            fax_req_date_sent: "2021-04-16 08:37:07",
            fax_req_number: "6057164337",
            fax_req_status: "delivered",
            fax_req_sid: "a5326932-385f-4743-842f-d7abb7bb5956",
          },
        ],
      },
      can_expedite: true,
      order_style: "status-medivo",
      canGenerateRequisition: false,
      result_collection_date: null,
      patient_id: 732087,
      sex: "M",
      race: "",
      ethnicity: "",
      sex_with: "",
      symptoms: "",
      pregnant: "",
      due_date: null,
      last_menstrual_date: null,
      address: null,
      doh_data: {
        id: 874458,
        patient_id: "732087",
        sex: "M",
        race: null,
        ethnicity: null,
        sex_with: null,
        symptoms: "",
        pregnant: null,
        last_menstrual_date: null,
        due_date: null,
        created_at: "2020-04-16T00:59:40.000000Z",
        updated_at: "2020-04-16T00:59:40.000000Z",
        deleted_at: null,
      },
      account: {
        accounts_id: 351972,
        email: "djn17@charter.net",
        phone: null,
        type: "email",
        first_name: "David",
        last_name: "Jones",
        locked: false,
        is_active: true,
        business_account_id: null,
        created_at: "2018-12-19 22:03:16",
        updated_at: "2020-10-24 09:25:52",
        deleted_at: null,
      },
      tests: [
        {
          customer_tests_id: 1289712,
          customer_tests_type: "Panel",
          customer_tests_name: "10 Test Panel with HIV RNA Early Detection",
          customer_tests_price: 34900,
          test_codes:
            "006734; 006510; 140659; 012005; 139350; 183194; 164897; 163033",
          cpt_code: null,
          customer_tests_customer_id: "732087",
          test_id: "1004",
          deleted_at: null,
          reference_id: null,
        },
      ],
      site: {
        id: 1,
        name: "STDcheck",
        url: "stdcheck.com",
        phone_number: "1-800-456-2323",
        merchant_id: "STDCheck",
        created_at: "2015-07-20T18:30:33.000000Z",
        updated_at: "2021-10-07T19:48:35.000000Z",
        deleted_at: null,
        icon: "stdcheck.ico",
      },
    },
  },
  {
    id: 1792320,
    title: "Test Confirmation",
    content:
      '<body><p>DAVID,</p><p>Thank you for choosing STDcheck for your testing needs. \u00a0Your order ID number is: qtswIEQrP2.</p><p>We have attached a form that you will need to take with you when you visit the lab. You can print the attachment out or fax it directly to the lab from the <strong>My Orders</strong> tab in your online account. \u00a0As soon as your results are completed, you will receive a notification either by email or text depending on your chosen preference when you placed your order.</p><p><strong>You selected this lab location:</strong></p><p style="line-height: 1;">Quest Diagnostics</p><p style="line-height: 1;">3030 Frank Scott Pkwy W, Ste 5</p><p style="line-height: 1;">Belleville, IL 62223</p><p>The time frame for taking an STD test varies based on the incubation period for the infection and can differ from person to person. Please see the following to find out the best time to take an STD test: Chlamydia 1-5 days; Gonorrhea 2-6 days; Syphilis 3-6 weeks; Hepatitis A 2-7 weeks; Hepatitis B 3-6 weeks; Hepatitis C 8-9 weeks; Herpes 1 &amp; 2 4-6 weeks; HIV 4th Generation 2-3 weeks and HIV RNA 9-11 days.</p><p>If you have any issues with your testing center, please contact us at 1-800-456-2323. When you arrive at the lab, sign in with the name you provided. <strong>You DO NOT need to show your ID or give your insurance information; if you are asked to, please refer them to the first page of your requisition.</strong></p><p>Additionally, please note that the charge on your bank statement will appear as "HealthLabs.com".</p><p>Best regards,<br>STDcheck.com</p><p><strong>IMPORTANT NOTES:</strong></p><ul><li>All HIV RNA tests can take an additional 24-48 hours for processing and testing.</li><li>Some test codes on the requisition form include more than one test.</li><li>If you are getting tested for Chlamydia and/or Gonorrhea please be sure not to urinate 60 minutes prior to visiting the testing center.</li><li>If you have purchased a Wellness Panel you will need to fast 12 hours prior to visiting the lab.</li><li>Please disregard the physician and patient signature lines located at the bottom of your requisition. These signatures are not necessary for testing.</li><li><span id="docs-internal-guid-5c94f16d-cf18-188a-6734-b0f62ddfbc96">We understand that waiting for results can be stressful. To help, we have compiled a list of ways to stay calm in the <a href="https://www.stdcheck.com/blog/ways-stay-calm-waiting-test-results/" rel="noopener noreferrer" target="_blank">meantime</a>.</span></li></ul></body>',
    user_id: "24",
    is_read: "YES",
    read_at: "2020-02-17T13:31:58.000000Z",
    to_email: "djn17@charter.net",
    to_sms: null,
    date: "2020-02-17T13:30:43.350272Z",
    pdf_id: null,
    correspondence_id: null,
    correspondence_type: null,
    deleted_at: null,
    deleted_by: null,
    order_id: "708526",
    encrypted_id:
      "eyJpdiI6IlJxTmhpaEt4L2NqQ2hrRUR0V0hZZlE9PSIsInZhbHVlIjoiMHc4aTVFNWN3SWYwL3BPNHI2bjZOdz09IiwibWFjIjoiYjZkMmY3NzdjNTUyNGVmMWUyZDU2YjM2ZmM1NzlmMGY2OTJjZmRiODIxMjc3Y2RjODQyZWQ2MTZiMzFmNDY2YSIsInRhZyI6IiJ9",
    attachments: [
      {
        account_msg_attach_id: 1514721,
        account_msg_attach_account_msg_id: "1792320",
        account_msg_attach_filename: "721640.pdf",
        disk: "requisitions",
        size: "191.97 KB",
        file_name: "721640.pdf",
        encrypted_account_msg_attach_id:
          "eyJpdiI6ImlWSkd6TmZMek9EYksrMGN6NzFvQmc9PSIsInZhbHVlIjoiMEo4OEJzUG50UmlCRDhSdThDbkIydz09IiwibWFjIjoiM2I0YjQyNGNlMWZhOWMxM2ZjMWRjOTRkOWVlNGQxNTM1ZGEzNDZlNmM4ODllYjIxNjdlMDUyZTBjZjhiZmVlYyIsInRhZyI6IiJ9",
      },
    ],
    sender: {
      users_manage_id: 24,
      users_manage_fname: "Health Labs",
      users_manage_lname: "Bot",
      users_manage_email: "support@stdcheck.com",
      users_manage_level: "user",
      users_manage_active: true,
      is_menu_visible: false,
      dose_spot_user_id: 135430,
      full_name: "Health Labs Bot",
      email: "support@stdcheck.com",
    },
    order: {
      customer_id: 708526,
      first_name: "DAVID",
      last_name: "JONES",
      gender: "M",
      date_of_birth: "1974-05-04T00:00:00",
      result_notification_method: "Email",
      result_notification_parameter: null,
      phone: "6184072431",
      leave_message: "NO",
      send_sms: false,
      is_active: true,
      awaiting_lab_confirmation: false,
      payment_status: "Not Paid",
      transaction_id: "qtswIEQrP2",
      site_id: "1",
      declined_consultation: false,
      network_account_id: "6",
      trace_requested: null,
      expedite_requested: null,
      created_at: "2020-02-17T07:27:48",
      updated_at: "2020-02-17T07:30:39",
      result_status: "None",
      ip_address: "75.132.172.144",
      created_by_id: null,
      awaiting_address_confirmation: false,
      business_account_id: null,
      kit_code: null,
      hash: "$2y$10$AZx6RmFu9thOVJsBD56iJu575UWhe0BJPzjweVUQ8FNGWxbL9zwca",
      account_type: "email",
      total_cost: 34700,
      total_payments: 0,
      total_pending: 0,
      consult_url: "",
      consult_url_base:
        "https://www.stdcheck.com/consultation/request?order_id=qtswIEQrP2",
      payment_due: true,
      status: "Active",
      requisition: {
        requisitions_id: 721640,
        requisitions_user_id: "24",
        requisitions_message_template_id: null,
        requisitions_date_sent: "2020-02-17T13:30:41.000000Z",
        faxed_by_patient_at: null,
        source: "iLab",
        lab_order_id: "1324578533",
        deleted_at: null,
        encrypted_requisitions_id:
          "eyJpdiI6InpDeW9oWnJ5UUdzR1dPaE1JMWRJREE9PSIsInZhbHVlIjoiRER1VTB0N3AyU25wRHZGbTJjODJqQT09IiwibWFjIjoiZmMzMjRhYjIwZDNjMjIyZDBkZmE0ODkyYWE2YjJkOTczY2I1YzU2NWUzY2NmOGE2OWVjMzBiYzgxZTk4OTZjZSIsInRhZyI6IiJ9",
        pdf_name: "721640.pdf",
        fax_req: [],
      },
      can_expedite: true,
      order_style: "status-ilab",
      canGenerateRequisition: false,
      result_collection_date: null,
      patient_id: 708526,
      sex: "M",
      race: "",
      ethnicity: "",
      sex_with: "",
      symptoms: "",
      pregnant: "",
      due_date: null,
      last_menstrual_date: null,
      address: {
        customer_address_id: 692487,
        customer_address_customer_id: "708526",
        customer_address_street: "12 South Ruby Lane",
        customer_address_city: "Fairview Heights",
        customer_address_state: "IL",
        customer_address_zip: "62208",
      },
      doh_data: {
        id: 850894,
        patient_id: "708526",
        sex: "M",
        race: null,
        ethnicity: null,
        sex_with: null,
        symptoms: "",
        pregnant: null,
        last_menstrual_date: null,
        due_date: null,
        created_at: "2020-02-17T13:27:48.000000Z",
        updated_at: "2020-02-17T13:27:48.000000Z",
        deleted_at: null,
      },
      account: {
        accounts_id: 351972,
        email: "djn17@charter.net",
        phone: null,
        type: "email",
        first_name: "David",
        last_name: "Jones",
        locked: false,
        is_active: true,
        business_account_id: null,
        created_at: "2018-12-19 22:03:16",
        updated_at: "2020-10-24 09:25:52",
        deleted_at: null,
      },
      tests: [
        {
          customer_tests_id: 1243571,
          customer_tests_type: "Panel",
          customer_tests_name: "10 Test Panel",
          customer_tests_price: 19800,
          test_codes: "512; 498; 8472; 91431; 36126; 11363; 3636; 3640",
          cpt_code: null,
          customer_tests_customer_id: "708526",
          test_id: "1003",
          deleted_at: null,
          reference_id: null,
        },
        {
          customer_tests_id: 1243572,
          customer_tests_type: "Upsell Panel",
          customer_tests_name:
            "Trichomoniasis Test + Comprehensive Wellness Panel with a Urinalysis",
          customer_tests_price: 14900,
          test_codes: "90801; 5463; 10231; 6399",
          cpt_code: null,
          customer_tests_customer_id: "708526",
          test_id: "1008",
          deleted_at: null,
          reference_id: null,
        },
      ],
      site: {
        id: 1,
        name: "STDcheck",
        url: "stdcheck.com",
        phone_number: "1-800-456-2323",
        merchant_id: "STDCheck",
        created_at: "2015-07-20T18:30:33.000000Z",
        updated_at: "2021-10-07T19:48:35.000000Z",
        deleted_at: null,
        icon: "stdcheck.ico",
      },
    },
  },
  {
    id: 1101202,
    title: "Testing Not Resulted",
    content:
      '<p>David,</p><p>Our records indicate it has been 14 days since you placed your lab order, and we have yet to receive your results.</p><p>There are two reasons why this would occur:</p><p><strong>1. You have yet to visit the lab</strong></p><p>If you have yet to visit the lab, please do so. You have chosen Labcorp, 1207 Thouvenot Lane, Suite 400 Shiloh, IL 62269 as your preferred testing center. If you would like to visit a different lab, you can log into your secure online account.</p><p><strong>2. The lab has yet to upload your results</strong></p><p>If you\u00e2\u20ac\u2122ve already visited the lab, please contact us immediately at 1-800-456-2323, option 2, so we may procure your results from them.</p><p>Additionally, please note that the charge on your bank statement would appear as "HealthLabs.com".</p><p>Best regards,&nbsp;</p><p>STDcheck.com</p><p><br></p><p>Order Reference ID: 8XrgDqj9v2</p>',
    user_id: "24",
    is_read: "NO",
    read_at: "2019-04-04T20:37:26.000000Z",
    to_email: "djn17@charter.net",
    to_sms: null,
    date: "2019-01-02T20:00:37.347727Z",
    pdf_id: null,
    correspondence_id: null,
    correspondence_type: null,
    deleted_at: null,
    deleted_by: null,
    order_id: "470999",
    encrypted_id:
      "eyJpdiI6IkZMMHhuNUhSL2hqd2lDOG03Y3NFQUE9PSIsInZhbHVlIjoiUW9Kc0xtYWxuU1JCSXhyaWxXTzBNUT09IiwibWFjIjoiYmRhZTFhM2U0NTE3NTJkYTgxNGJkYmY3Mjk3MWRiMzBjYzdiYmFiMmM5OGQxYTcxMDJmMDJhODY4MDEyY2E5YiIsInRhZyI6IiJ9",
    attachments: [],
    sender: {
      users_manage_id: 24,
      users_manage_fname: "Health Labs",
      users_manage_lname: "Bot",
      users_manage_email: "support@stdcheck.com",
      users_manage_level: "user",
      users_manage_active: true,
      is_menu_visible: false,
      dose_spot_user_id: 135430,
      full_name: "Health Labs Bot",
      email: "support@stdcheck.com",
    },
    order: {
      customer_id: 470999,
      first_name: "DAVID",
      last_name: "JONES",
      gender: "M",
      date_of_birth: "1974-05-04T00:00:00",
      result_notification_method: "Email",
      result_notification_parameter: null,
      phone: "6184072431",
      leave_message: "NO",
      send_sms: false,
      is_active: true,
      awaiting_lab_confirmation: false,
      payment_status: "Not Paid",
      transaction_id: "8XrgDqj9v2",
      site_id: "1",
      declined_consultation: false,
      network_account_id: "1",
      trace_requested: null,
      expedite_requested: null,
      created_at: "2018-12-19T22:03:16",
      updated_at: "2019-08-07T13:55:15",
      result_status: "None",
      ip_address: null,
      created_by_id: null,
      awaiting_address_confirmation: false,
      business_account_id: null,
      kit_code: null,
      hash: "$2y$10$/9nDBAEMQYy9UNYR16joDejgIg4fR/N8EC6bNDq0xssDOAFbY214O",
      account_type: "email",
      total_cost: 2400,
      total_payments: 0,
      total_pending: 0,
      consult_url: "",
      consult_url_base:
        "https://www.stdcheck.com/consultation/request?order_id=8XrgDqj9v2",
      payment_due: true,
      status: "Active",
      requisition: {
        requisitions_id: 477063,
        requisitions_user_id: "24",
        requisitions_message_template_id: null,
        requisitions_date_sent: "2018-12-19T22:05:13.000000Z",
        faxed_by_patient_at: "2019-04-25T14:33:25.000000Z",
        source: "Medivo",
        lab_order_id: "1324324629",
        deleted_at: null,
        encrypted_requisitions_id:
          "eyJpdiI6IlZId1k1NHZMUTZwakVncGp5cWtIQXc9PSIsInZhbHVlIjoiNUVUNkRCMFN6R1FvZHF4ZlpEQi9LUT09IiwibWFjIjoiM2QxMGZkMjZjYmVjYmI2NDI0MjQ1YzkxYzk3YzJhZDJmYzlhZWIwYTY4YjRhMzE2MTcwYTcyZjc0YzBiNzYxMSIsInRhZyI6IiJ9",
        pdf_name: "477063.pdf",
        fax_req: [
          {
            fax_req_id: 122086,
            fax_req_requisition_id: "477063",
            fax_req_user_id: "24",
            fax_req_date_sent: "2018-12-19 18:21:18",
            fax_req_number: "6182357672",
            fax_req_status: "delivered",
            fax_req_sid: "FXa35cd4bca38e29f305ddfed1ee0a43f2",
          },
          {
            fax_req_id: 154741,
            fax_req_requisition_id: "477063",
            fax_req_user_id: "24",
            fax_req_date_sent: "2019-04-25 09:33:25",
            fax_req_number: "6182357672",
            fax_req_status: "delivered",
            fax_req_sid: "FX07043de956dc3b2a8495291b29a33648",
          },
        ],
      },
      can_expedite: true,
      order_style: "status-medivo",
      canGenerateRequisition: false,
      result_collection_date: null,
      patient_id: 470999,
      sex: "M",
      race: "",
      ethnicity: "",
      sex_with: "",
      symptoms: "",
      pregnant: "",
      due_date: null,
      last_menstrual_date: null,
      address: {
        customer_address_id: 460954,
        customer_address_customer_id: "470999",
        customer_address_street: "12 South Ruby Lane",
        customer_address_city: "Fairview Heights",
        customer_address_state: "IL",
        customer_address_zip: "62208",
      },
      doh_data: {
        id: 646433,
        patient_id: "470999",
        sex: "M",
        race: null,
        ethnicity: null,
        sex_with: null,
        symptoms: "",
        pregnant: null,
        last_menstrual_date: null,
        due_date: null,
        created_at: null,
        updated_at: null,
        deleted_at: null,
      },
      account: {
        accounts_id: 351972,
        email: "djn17@charter.net",
        phone: null,
        type: "email",
        first_name: "David",
        last_name: "Jones",
        locked: false,
        is_active: true,
        business_account_id: null,
        created_at: "2018-12-19 22:03:16",
        updated_at: "2020-10-24 09:25:52",
        deleted_at: null,
      },
      tests: [
        {
          customer_tests_id: 805845,
          customer_tests_type: "Individual",
          customer_tests_name: "Hepatitis A",
          customer_tests_price: 2400,
          test_codes: "006734",
          cpt_code: "86709",
          customer_tests_customer_id: "470999",
          test_id: "4",
          deleted_at: null,
          reference_id: "2034",
        },
      ],
      site: {
        id: 1,
        name: "STDcheck",
        url: "stdcheck.com",
        phone_number: "1-800-456-2323",
        merchant_id: "STDCheck",
        created_at: "2015-07-20T18:30:33.000000Z",
        updated_at: "2021-10-07T19:48:35.000000Z",
        deleted_at: null,
        icon: "stdcheck.ico",
      },
    },
  },
  {
    id: 1083508,
    title: "Test Confirmation",
    content:
      '<body><p>Your order ID number is: 8XrgDqj9v2</p><p>We have attached a form that you will need to have with you when you visit the lab. You can print the attachment out or fax it directly to the lab from the <b>My Orders</b> tab in your online account and take it with you to your nearest Labcorp\u00c2\u00a0location. Labcorp will perform the testing.</p><p>As soon as your results are completed, you will receive a notification either by email or text depending on your chosen preference when you placed your order.</p><p>The time frame for taking an STD test varies based on the incubation period for the infection and can differ from person to person. Please see the following to find out the best time to take an STD test: Chlamydia 1-5 days; Gonorrhea 2-6 days; Syphilis 3-6 weeks; Hepatitis A 2-7 weeks; Hepatitis B 3-6 weeks; Hepatitis C 8-9 weeks; Herpes 1 &amp; 2 4-6 weeks; HIV 4th Generation 2-3 weeks and HIV RNA 9-11 days.</p><p>If you have any issues with your testing center, please contact us at 1-800-456-2323. When you arrive at the lab, sign in with the name you provided. You\u00c2\u00a0DO NOT\u00c2\u00a0need to show your ID or give your insurance information; if you are asked to, please refer them to the first page of your requisition.</p><p>Additionally, please note that the charge on your bank statement will appear as "HealthLabs.com".</p><p>Best regards,\u00c2\u00a0<br>STDcheck.com</p><p><strong>IMPORTANT NOTES:</strong></p><ul><li>All HIV RNA tests can take an additional 24-48 hours for processing and testing.</li><li>Some test codes on the requisition form include more than one test.</li><li>If you are getting tested for Chlamydia and/or Gonorrhea please be sure not to urinate 60 minutes prior to visiting the testing center.</li><li>If you have purchased a Wellness Panel you will need to fast 12 hours prior to visiting the lab.</li><li>Please disregard the physician and patient signature lines located at the bottom of your requisition. These signatures are not necessary for testing.</li><li><span id="docs-internal-guid-5c94f16d-cf18-188a-6734-b0f62ddfbc96">We understand that waiting for results can be stressful. To help, we have compiled a list of ways to stay calm in the <a href="https://www.stdcheck.com/blog/ways-stay-calm-waiting-test-results/?utm_source=email&amp;utm_medium=check-requisition" target="_blank" rel="noopener noreferrer">meantime</a>.</span></li></ul></body>',
    user_id: "24",
    is_read: "YES",
    read_at: "2018-12-20T04:09:25.000000Z",
    to_email: "djn17@charter.net",
    to_sms: null,
    date: "2018-12-20T04:05:18.960048Z",
    pdf_id: null,
    correspondence_id: null,
    correspondence_type: null,
    deleted_at: null,
    deleted_by: null,
    order_id: "470999",
    encrypted_id:
      "eyJpdiI6Ijh0cStJSTFlamhRRU5lNUtRYmc5eEE9PSIsInZhbHVlIjoiWXl4K2dTa05RdWw2QzBOTktleGJsUT09IiwibWFjIjoiMmMyZGExYTFmNzhkMWM2ZjQwYTFjYTFmMmE3NGEwZDNkOGNiMjIyYzkyZWNkOWM2MWVlMTJhMTY0YTNkMjk5OSIsInRhZyI6IiJ9",
    attachments: [
      {
        account_msg_attach_id: 932661,
        account_msg_attach_account_msg_id: "1083508",
        account_msg_attach_filename: "477063.pdf",
        disk: "requisitions",
        size: "49.19 KB",
        file_name: "477063.pdf",
        encrypted_account_msg_attach_id:
          "eyJpdiI6InlwTUtLNVhVOXhqMks3bFlGdFhXekE9PSIsInZhbHVlIjoic1BoeHB2OWtZczlod1NhWWU1bFJnUT09IiwibWFjIjoiZjA4Yzc3MTJiODE4ZDk4MDNhN2U2YzlmN2VjOWQ4NTI4MWMyM2RjNjdlMmE4MzdmYzkwMTY5MThiZTA4YmI3ZSIsInRhZyI6IiJ9",
      },
    ],
    sender: {
      users_manage_id: 24,
      users_manage_fname: "Health Labs",
      users_manage_lname: "Bot",
      users_manage_email: "support@stdcheck.com",
      users_manage_level: "user",
      users_manage_active: true,
      is_menu_visible: false,
      dose_spot_user_id: 135430,
      full_name: "Health Labs Bot",
      email: "support@stdcheck.com",
    },
    order: {
      customer_id: 470999,
      first_name: "DAVID",
      last_name: "JONES",
      gender: "M",
      date_of_birth: "1974-05-04T00:00:00",
      result_notification_method: "Email",
      result_notification_parameter: null,
      phone: "6184072431",
      leave_message: "NO",
      send_sms: false,
      is_active: true,
      awaiting_lab_confirmation: false,
      payment_status: "Not Paid",
      transaction_id: "8XrgDqj9v2",
      site_id: "1",
      declined_consultation: false,
      network_account_id: "1",
      trace_requested: null,
      expedite_requested: null,
      created_at: "2018-12-19T22:03:16",
      updated_at: "2019-08-07T13:55:15",
      result_status: "None",
      ip_address: null,
      created_by_id: null,
      awaiting_address_confirmation: false,
      business_account_id: null,
      kit_code: null,
      hash: "$2y$10$ssRxlGndrmgPtnqQiA0zOO7HJtD5BcjphFQTuT7FDY5ntUePA3kTa",
      account_type: "email",
      total_cost: 2400,
      total_payments: 0,
      total_pending: 0,
      consult_url: "",
      consult_url_base:
        "https://www.stdcheck.com/consultation/request?order_id=8XrgDqj9v2",
      payment_due: true,
      status: "Active",
      requisition: {
        requisitions_id: 477063,
        requisitions_user_id: "24",
        requisitions_message_template_id: null,
        requisitions_date_sent: "2018-12-19T22:05:13.000000Z",
        faxed_by_patient_at: "2019-04-25T14:33:25.000000Z",
        source: "Medivo",
        lab_order_id: "1324324629",
        deleted_at: null,
        encrypted_requisitions_id:
          "eyJpdiI6InBpOFdKWFdZN1pLeURvejYwS2hab3c9PSIsInZhbHVlIjoid054cUdsYnhBL3kvakRlVW5DMTBldz09IiwibWFjIjoiYmU1ZWI3Yzc3YzNjMmYxZWJlYTBmYmEyNjMzNTllNGVlOGIwYzFjYWU1YTYxYTE5NjcwMGM3MzdiNmRkMzdjOSIsInRhZyI6IiJ9",
        pdf_name: "477063.pdf",
        fax_req: [
          {
            fax_req_id: 122086,
            fax_req_requisition_id: "477063",
            fax_req_user_id: "24",
            fax_req_date_sent: "2018-12-19 18:21:18",
            fax_req_number: "6182357672",
            fax_req_status: "delivered",
            fax_req_sid: "FXa35cd4bca38e29f305ddfed1ee0a43f2",
          },
          {
            fax_req_id: 154741,
            fax_req_requisition_id: "477063",
            fax_req_user_id: "24",
            fax_req_date_sent: "2019-04-25 09:33:25",
            fax_req_number: "6182357672",
            fax_req_status: "delivered",
            fax_req_sid: "FX07043de956dc3b2a8495291b29a33648",
          },
        ],
      },
      can_expedite: true,
      order_style: "status-medivo",
      canGenerateRequisition: false,
      result_collection_date: null,
      patient_id: 470999,
      sex: "M",
      race: "",
      ethnicity: "",
      sex_with: "",
      symptoms: "",
      pregnant: "",
      due_date: null,
      last_menstrual_date: null,
      address: {
        customer_address_id: 460954,
        customer_address_customer_id: "470999",
        customer_address_street: "12 South Ruby Lane",
        customer_address_city: "Fairview Heights",
        customer_address_state: "IL",
        customer_address_zip: "62208",
      },
      doh_data: {
        id: 646433,
        patient_id: "470999",
        sex: "M",
        race: null,
        ethnicity: null,
        sex_with: null,
        symptoms: "",
        pregnant: null,
        last_menstrual_date: null,
        due_date: null,
        created_at: null,
        updated_at: null,
        deleted_at: null,
      },
      account: {
        accounts_id: 351972,
        email: "djn17@charter.net",
        phone: null,
        type: "email",
        first_name: "David",
        last_name: "Jones",
        locked: false,
        is_active: true,
        business_account_id: null,
        created_at: "2018-12-19 22:03:16",
        updated_at: "2020-10-24 09:25:52",
        deleted_at: null,
      },
      tests: [
        {
          customer_tests_id: 805845,
          customer_tests_type: "Individual",
          customer_tests_name: "Hepatitis A",
          customer_tests_price: 2400,
          test_codes: "006734",
          cpt_code: "86709",
          customer_tests_customer_id: "470999",
          test_id: "4",
          deleted_at: null,
          reference_id: "2034",
        },
      ],
      site: {
        id: 1,
        name: "STDcheck",
        url: "stdcheck.com",
        phone_number: "1-800-456-2323",
        merchant_id: "STDCheck",
        created_at: "2015-07-20T18:30:33.000000Z",
        updated_at: "2021-10-07T19:48:35.000000Z",
        deleted_at: null,
        icon: "stdcheck.ico",
      },
    },
  },
];

export default test_messages;
